module.exports = __webpack_public_path__ + "img/NuvamaLogo.422d79f0.jpeg";